(() => {
  const key = 'sleq-bodyweight-controller';
  if (window[key]) { window[key].init(document); return; }
  const instances = new Map();
  function mount(root) {
    if (instances.has(root)) return;
    const abort = new AbortController();
    const options = { signal: abort.signal };
    const openers = new WeakMap();
    root.addEventListener('click', event => {
      const opener = event.target.closest('[data-sleq-bodyweight-open]');
      if (opener && root.contains(opener)) {
        const dialog = document.getElementById(opener.dataset.sleqBodyweightOpen);
        if (dialog && root.contains(dialog) && !dialog.open) { openers.set(dialog, opener); dialog.showModal(); }
      }
      const close = event.target.closest('[data-sleq-bodyweight-close]');
      if (close) close.closest('dialog')?.close();
      if (event.target.tagName === 'DIALOG') {
        const r = event.target.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) event.target.close();
      }
    }, options);
    root.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('close', () => {
      dialog.querySelectorAll('video').forEach(video => video.pause());
      openers.get(dialog)?.focus({ preventScroll: true });
    }, options));
    const carousels = [];
    root.querySelectorAll('[data-sleq-bodyweight-track]').forEach(track => {
      const block = track.closest('.sleq-bodyweight-block');
      const prev = block.querySelector('[data-sleq-bodyweight-prev]');
      const next = block.querySelector('[data-sleq-bodyweight-next]');
      const dots = [...block.querySelectorAll('[data-sleq-bodyweight-slide]')];
      const status = block.querySelector('[data-sleq-bodyweight-status]');
      let current = 0;
      const visible = () => [...track.children].filter(card => card.offsetWidth > 0);
      const update = () => {
        const cards = visible();
        const offset = track.getBoundingClientRect().left;
        let best = Infinity;
        cards.forEach((card, index) => { const distance = Math.abs(card.getBoundingClientRect().left - offset); if (distance < best) { best = distance; current = index; } });
        prev.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        dots.forEach((dot, index) => dot.setAttribute('aria-pressed', String(index === current)));
      };
      const go = index => {
        const cards = visible();
        index = Math.max(0, Math.min(cards.length - 1, index));
        const card = cards[index];
        if (!card) return;
        const left = card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
        track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        status.textContent = `${index + 1} / ${cards.length}: ${card.querySelector('h3')?.textContent || ''}`;
      };
      prev.addEventListener('click', () => go(current - 1), options);
      next.addEventListener('click', () => go(current + 1), options);
      dots.forEach((dot, index) => dot.addEventListener('click', () => go(index), options));
      track.addEventListener('keydown', event => {
        if (!matchMedia('(max-width: 749px)').matches) return;
        if (['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          go(event.key === 'Home' ? 0 : event.key === 'End' ? visible().length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      track.addEventListener('scroll', update, { ...options, passive: true });
      const resize = new ResizeObserver(update); resize.observe(track);
      carousels.push({ resize, update }); update();
    });
    instances.set(root, () => { abort.abort(); carousels.forEach(c => c.resize.disconnect()); root.querySelectorAll('dialog[open]').forEach(d => d.close()); });
  }
  function init(scope) {
    for (const [root, dispose] of instances) if (!root.isConnected) { dispose(); instances.delete(root); }
    if (scope.matches?.('.sleq-bodyweight-guide')) mount(scope);
    scope.querySelectorAll?.('.sleq-bodyweight-guide').forEach(mount);
  }
  window[key] = { init };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, dispose] of instances) if (event.target.contains(root)) { dispose(); instances.delete(root); }
  });
  init(document);
})();
